/* eslint-disable react/prop-types */
import React, {useContext, useEffect, useState} from 'react';

// put in export files - kb
import './OrginazationPage.scss';
import {Context} from '../../../context/dataStore';
import {Context_role} from '../../../context/rolesStore';
import {TableComponent, BandLayout} from '../../../components';
import {ADMIN_ROLE, BCFP_ROLES_ARR} from '../../../constants/global';
import { HE_LANDING_REMINDER, BFCP_LIVE } from '../../../constants/reminder';
import { useNavigate } from 'react-router-dom';

export default function MultipleOrganizations() {
  let navigate = useNavigate();
  const {state: {reminderData}} = useContext(Context);
  const {state: {newroles}} = useContext(Context_role);
  const [is_BCFP_LIVE, set_BCFP_LIVE] = useState('');

  // ---COMPONENT DID MOUNT LIFE CYCLE
  useEffect(()=>{
    const applicationDataLayer = {page:{pageCode: "organizationpage"}};
    if(typeof kiwi !== 'undefined') kiwi.mergeDdl(applicationDataLayer);
    if(typeof _satellite !== 'undefined') _satellite.track('cbTrack.viewInDom');
  },[]);

  //--used to get the bcfp live flag
  useEffect(() => reminderData?.forEach(el => {
    if(el.code===BFCP_LIVE) {
      set_BCFP_LIVE(`${el.value}`);
    }
  }), [reminderData]);

  // ---REDIRECT WHEN LIVE
  //--'false' means we are not live so BLOCK OUR APP
  if(is_BCFP_LIVE==='false' && BCFP_ROLES_ARR.includes(newroles[0])) {
    navigate('/bfcp_is_ready_comingsoon');
  }
  //redirect when you are admin
  if(newroles[0]===ADMIN_ROLE) {
    navigate('/adminpage');
  }
  return (
    <div>
      <div style={{marginBottom: '20px'}}>
        <BandLayout metaData={HE_LANDING_REMINDER} />
      </div>
      <div>
        <TableComponent tableheaders={["Institution", "Org ID", "State", "Zone"]} />
      </div>
    </div>
  );
}